const bangladeshDivisionsAndDistricts = [
  {
    division: { en: "Dhaka", bn: "ঢাকা" },
    districts: [
      { en: "Dhaka", bn: "ঢাকা" },
      { en: "Gazipur", bn: "গাজীপুর" },
      { en: "Narayanganj", bn: "নারায়ণগঞ্জ" },
      { en: "Manikganj", bn: "মানিকগঞ্জ" },
      { en: "Munshiganj", bn: "মুন্সিগঞ্জ" },
      { en: "Rajbari", bn: "রাজবাড়ী" },
      { en: "Madaripur", bn: "মাদারীপুর" },
      { en: "Gopalganj", bn: "গোপালগঞ্জ" },
      { en: "Faridpur", bn: "ফরিদপুর" },
      { en: "Tangail", bn: "টাঙ্গাইল" },
      { en: "Kishoreganj", bn: "কিশোরগঞ্জ" },
      { en: "Narsingdi", bn: "নরসিংদী" },
      { en: "Shariatpur", bn: "শরীয়তপুর" }
    ]
  },
  {
    division: { en: "Chittagong", bn: "চট্টগ্রাম" },
    districts: [
      { en: "Chittagong", bn: "চট্টগ্রাম" },
      { en: "Cox's Bazar", bn: "কক্সবাজার" },
      { en: "Rangamati", bn: "রাঙ্গামাটি" },
      { en: "Bandarban", bn: "বান্দরবান" },
      { en: "Khagrachhari", bn: "খাগড়াছড়ি" },
      { en: "Feni", bn: "ফেনী" },
      { en: "Noakhali", bn: "নোয়াখালী" },
      { en: "Lakshmipur", bn: "লক্ষ্মীপুর" },
      { en: "Chandpur", bn: "চাঁদপুর" },
      { en: "Brahmanbaria", bn: "ব্রাহ্মণবাড়িয়া" },
      { en: "Comilla", bn: "কুমিল্লা" }
    ]
  },
  {
    division: { en: "Rajshahi", bn: "রাজশাহী" },
    districts: [
      { en: "Rajshahi", bn: "রাজশাহী" },
      { en: "Natore", bn: "নাটোর" },
      { en: "Naogaon", bn: "নওগাঁ" },
      { en: "Chapai Nawabganj", bn: "চাঁপাইনবাবগঞ্জ" },
      { en: "Pabna", bn: "পাবনা" },
      { en: "Sirajganj", bn: "সিরাজগঞ্জ" },
      { en: "Bogra", bn: "বগুড়া" },
      { en: "Joypurhat", bn: "জয়পুরহাট" }
    ]
  },
  {
    division: { en: "Khulna", bn: "খুলনা" },
    districts: [
      { en: "Khulna", bn: "খুলনা" },
      { en: "Bagerhat", bn: "বাগেরহাট" },
      { en: "Satkhira", bn: "সাতক্ষীরা" },
      { en: "Jessore", bn: "যশোর" },
      { en: "Chuadanga", bn: "চুয়াডাঙ্গা" },
      { en: "Kushtia", bn: "কুষ্টিয়া" },
      { en: "Magura", bn: "মাগুরা" },
      { en: "Meherpur", bn: "মেহেরপুর" },
      { en: "Jhenaidah", bn: "ঝিনাইদহ" },
      { en: "Narail", bn: "নড়াইল" }
    ]
  },
  {
    division: { en: "Barisal", bn: "বরিশাল" },
    districts: [
      { en: "Barisal", bn: "বরিশাল" },
      { en: "Patuakhali", bn: "পটুয়াখালী" },
      { en: "Bhola", bn: "ভোলা" },
      { en: "Pirojpur", bn: "পিরোজপুর" },
      { en: "Barguna", bn: "বরগুনা" },
      { en: "Jhalokati", bn: "ঝালকাঠি" }
    ]
  },
  {
    division: { en: "Sylhet", bn: "সিলেট" },
    districts: [
      { en: "Sylhet", bn: "সিলেট" },
      { en: "Moulvibazar", bn: "মৌলভীবাজার" },
      { en: "Habiganj", bn: "হবিগঞ্জ" },
      { en: "Sunamganj", bn: "সুনামগঞ্জ" }
    ]
  },
  {
    division: { en: "Rangpur", bn: "রংপুর" },
    districts: [
      { en: "Rangpur", bn: "রংপুর" },
      { en: "Dinajpur", bn: "দিনাজপুর" },
      { en: "Gaibandha", bn: "গাইবান্ধা" },
      { en: "Kurigram", bn: "কুড়িগ্রাম" },
      { en: "Lalmonirhat", bn: "লালমনিরহাট" },
      { en: "Nilphamari", bn: "নীলফামারী" },
      { en: "Panchagarh", bn: "পঞ্চগড়" },
      { en: "Thakurgaon", bn: "ঠাকুরগাঁও" }
    ]
  },
  {
    division: { en: "Mymensingh", bn: "ময়মনসিংহ" },
    districts: [
      { en: "Mymensingh", bn: "ময়মনসিংহ" },
      { en: "Sherpur", bn: "শেরপুর" },
      { en: "Netrokona", bn: "নেত্রকোণা" },
      { en: "Jamalpur", bn: "জামালপুর" }
    ]
  }
];

export default bangladeshDivisionsAndDistricts;